import i18next from "i18next";
import { toPairs } from "ramda";
import { UAParser } from "ua-parser-js";

import {
  KEY_SHORTFORM_MAP,
  MAC_TO_WINDOWS_KEYS_MAP,
  OS,
  TOOLTIP_CONTENT,
} from "./constants";

const isMultipleHotkey = hotkey => Array.isArray(hotkey);

const replaceKeys = (hotkey, keyName, replaceWith) =>
  isMultipleHotkey(hotkey)
    ? hotkey.map(item => item.replaceAll(keyName, replaceWith))
    : hotkey.replaceAll(keyName, replaceWith);

const convertHotKeyToWindows = hotkey => {
  toPairs(MAC_TO_WINDOWS_KEYS_MAP).forEach(([macKey, windowsKey]) => {
    hotkey = replaceKeys(hotkey, macKey, windowsKey);
  });

  return hotkey;
};

export const convertHotkeyToUsersPlatform = hotkey => {
  const parser = new UAParser(navigator.userAgent);
  const result = parser.getResult();
  const isOSX = result.os.name?.includes(OS.mac);
  if (isOSX) return hotkey;

  return convertHotKeyToWindows(hotkey);
};

export const shortenHotKey = hotkey => {
  let result = hotkey;
  Object.entries(KEY_SHORTFORM_MAP).forEach(([longform, shortform]) => {
    result = result.replaceAll(longform, shortform);
  });

  return result;
};

export const getGlobalShortcuts = () => ({
  [i18next.t("neetoMolecules.keyboardShortcuts.global.categoryName")]: {
    openKeyboardShortcutsPane: {
      sequence: "command+/",
      description: i18next.t(
        "neetoMolecules.keyboardShortcuts.global.openKeyboardShortcutsPane"
      ),
    },
    close: {
      sequence: "esc",
      description: i18next.t("neetoMolecules.keyboardShortcuts.global.close"),
    },
    submitForm: {
      sequence: "command+return",
      description: i18next.t(
        "neetoMolecules.keyboardShortcuts.global.submitForm"
      ),
    },
    openProductSwitcher: {
      sequence: "command+u",
      description: i18next.t(
        "neetoMolecules.keyboardShortcuts.global.openProductSwitcher"
      ),
    },
  },
});

export const getTooltipProps = key => {
  if (TOOLTIP_CONTENT[key]) {
    return {
      position: "top",
      content: TOOLTIP_CONTENT[key],
      followCursor: "horizontal",
    };
  }

  return null;
};
